import * as _includes from 'lodash/includes';

export function includes<T>(obj: T, value: any, fromIndex: number = 0): boolean {
  return _includes(obj, value, fromIndex);
}
